import { isMobile, isMobileOnly } from 'react-device-detect';

// Phone-class only: tablets and larger keep the desktop web interface.
export function isMobileBrowser(): boolean {
  return isMobileOnly;
}

// Phones and tablets: the device classes that resolve to Gearbelt Mobile Web.
export function isMobileOrTabletBrowser(): boolean {
  return isMobile;
}
